// extracted by mini-css-extract-plugin
export var closeButton = "_11-5";
export var container = "_11-0";
export var contentContainer = "_11-1";
export var desktop = "_11-2";
export var fullModalImage = "_11-6";
export var mobile = "_11-3";
export var withImage = "_11-4";